import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "D:/git/misce/carbon/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`MISCE is focused on improving the acquisition of competences in different branch of engineering degrees by developing standardized material and good practices for practical
classes.`}</p>
      <p>{`The identification of the professional competences to be improved will involve professors, students and professional. Following, the devices and the teaching material will be designed by the mechatronics partners. This stage is an iterative process which require both, reengineering tasks and monitoring the level of competences acquisition.`}</p>
      <p>{`The standardized teaching material will be shared by digital repositories to diffuse the results of the project. Finally, a VET Competences Network will be created which allows to encourage the use and improvement of standardized material for competences acquisition`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">The consortium</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Priorities</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Topics</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Objectives</AnchorLink>
    </AnchorLinks>
    <h2>{`The consortium`}</h2>
    <Row className="image-card-group" mdxType="Row">
    
      <Column colMd={3} colLg={3} noGutterSm mdxType="Column">
        <ImageCard subTitle="Universidad de Castilla-La Mancha" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.uclm.es" mdxType="ImageCard">
          <img {...{
            "src": "/misce/337c27ce031879d4abe5d59a0141b7aa/UCLM.svg",
            "alt": "UCLMlogo"
          }}></img>
        </ImageCard>
        <ImageCard subTitle="Universidade do Minho" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.uminho.pt/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/710819b39e6e62f7bd935dcb9c03db8d/UMinho.svg",
            "alt": "UMinhologo"
          }}></img>
        </ImageCard>
      </Column>
      <Column colMd={3} colLg={3} noGutterSm mdxType="Column">
        <ImageCard subTitle="Universitat Politecnica de Valencia" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.upv.es/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/ab9f8116fb117f7f3064bdb683ab8b02/UPV.svg",
            "alt": "UPVlogo"
          }}></img>
        </ImageCard>
        <ImageCard subTitle="Politechnika Rzeszowska im. Ignacego Łukasiewicza" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://w.prz.edu.pl/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/c70855bda8d71397d61915bd539ca9af/PRZ.svg",
            "alt": "PRZlogo"
          }}></img>
        </ImageCard>
      </Column>
      <Column colMd={3} colLg={3} noGutterSm mdxType="Column">
        <ImageCard subTitle="Università degli Studi di Cassino e del Lazio Meridionale" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.unicas.it/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/d729833f2fbc87da72488a140c5e8aef/UNICAS.svg",
            "alt": "UNICASlogo"
          }}></img>
        </ImageCard>
        <ImageCard subTitle="Institute of European Certification of Personnel" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.iceponline.com/" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "726px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0klEQVQ4y81UW0tjVxReqdQpY1pQmA5mevHNP1CY/oC+OI1FaYc+iD5Y461Ek5Pk5CR7n5OcJOaK0WjjFaxtE6OJICoKXiCRURJ0LN5evMYH33ypKbRT6D677ANT+lDKzDx1wXf2Omuv/e1v7X3WAfjfG0mWazZiX8DwdylNxf17UFVVBRXaCqisrHwzQuUngPWBOhiMJUB7/x3QarVQXl6ujm9kpR/e+2Cp/8v3Y7EfP9RVP3xYU1PzgFIKRqOxTJKk/4QoimUul6vM5/NpotEohEIhADoD3z8b+szc3z/jL9MAAoC2x58+hkQiARzHgdlsBlEUASGk+larFRwOB/T29oLdbgen06nCYrG8FQwGAYb7vn3SJzu/drk8T9vavnna1dX1ldfr/VySJL3ZbFYhy7JeFEW9yWTSW61WPcZYz3Gc3ul06m022xOE0MdNTU1wfn4O4ETSzwhhKooijcfjNBqNUkEQqNPppIODg3RgYIDa7XaKMaZDQ0M0HA5Tl8ul5rndbhoKhajH4/ldEIRwbW0tAMZonyULgkDy+byyt7encBxH1tbWyPj4ONnY2CCrq6tkYWGBTExMkEwmQ5aWlsj19TXZ3t4miUSC7O7u0pGREcrzvAgY432mjuO4P1OplLK1taUkk0nl6OhIMRqNiiiKyv7+vnJwcKB4PB5lcnJSOT4+VorForK4uKi0t7ezGLm5uWFVvvib0GKxkPn5ebq5uUmz2SwtFApsExXLy8v0pYrp6Wl1vLy8pKlUilqtVsXn89Hb21uFlc8In79UmE6nSS6XI7Ozs6RYLBJWek9PDykUCiSbzRKDwaDGeJ4nV1dXSjqdVlgsHo+Ti4sLBSFEGOEBO0N28Ovr6/T09JTKskzz+TxdWVmhU1NTdGZmhuZyOZrJZGgymaRjY2P07OyMHh4e0rm5Obqzs6NeKM/zqsJnCKEXoij+4vf7S8FgsORyuUqCINzFYrG7cDhc4nn+DiFUGh0dLQ0PD5cQQr+enJz8kUgkfotEIiWv11uy2+0ljHGJfbQPJEl6hBDSdXR06FpbW3UOh0Mny3J1Q0NDdUtLi87v91ez+fr6+keNjY06QRCqIpHIic/nMwLAPZPJ9FEgENBhjHVqFzBgjKG7uxsMBgMIggA8z0NzczN0dnaqXWKz2aCurk7tlmAw+AnG+NDtdocopRqWz9YzHvbQ/BswxhqEkArm/yMOHo/n3VQq9XYoFNK63e5ytokkSer8K/9EWONLkqSq8Hq96ntfX5/qMzD/tYwRuN1uFWyxLMtMKQQCAfD7/a9P+Kr2FwmnXixqZDDAAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "ICEPlogo",
              "title": "ICEPlogo",
              "src": "/misce/static/7514caa68e676f080b7c0d1b571e9d96/81f3f/icep.png",
              "srcSet": ["/misce/static/7514caa68e676f080b7c0d1b571e9d96/7fc1e/icep.png 288w", "/misce/static/7514caa68e676f080b7c0d1b571e9d96/a5df1/icep.png 576w", "/misce/static/7514caa68e676f080b7c0d1b571e9d96/81f3f/icep.png 726w"],
              "sizes": "(max-width: 726px) 100vw, 726px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
      </Column>
      <Column colMd={3} colLg={3} noGutterSm mdxType="Column">
        <ImageCard subTitle="Università degli Studi di Cagliari" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.unica.it/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/aceeb29e38fec8e338e3f1700d24edef/unica.svg",
            "alt": "UNICAlogo"
          }}></img>
        </ImageCard>
        <ImageCard subTitle="Žilinská univerzita v Žiline" subTitleColor="dark" actionIcon="arrowRight" aspectRatio="1:1" href="https://www.uniza.sk/" mdxType="ImageCard">
          <img {...{
            "src": "/misce/14570625ca27eb6abc802e8a3fdee6fc/UNIZA.svg",
            "alt": "UNIZAlogo"
          }}></img>
        </ImageCard>
      </Column>
    </Row>
    <h2>{`Priorities`}</h2>
    <Accordion mdxType="Accordion">
    <AccordionItem title="HE: Stimulating innovative learning and teaching practices" mdxType="AccordionItem">
        According to the <em>Global Trends to 2030: Can the EU meet the challenges ahead? 
        The European Strategy and Policy Analysis System Report</em>, Europe will be the oldest 
        region in the world. While investment in robotics, automation and new technologies 
        related to mechatronics offer the opportunity to re-shore manufacturing in Europe, a 
        lack of skilled individuals and talents will create a bottleneck in this process.
    </AccordionItem>
    <AccordionItem title="HE: Developing STEM/STEAM in higher education, in particular women participation in STEM" mdxType="AccordionItem">
        In the last decades European Union makes efforts to close the gender gap, we can 
        see some improvement but in the engineering disciplines at universities the situation 
        is not yet so optimistic.  As an example, focusing on the universities involved in 
        the project proposal, female students represent only 15.5% (in academic year 2017/2018) 
        from all students at School of Industrial and Aerospace Engineering of Toledo (Spain) 
        but the level of woman at University of Cagliari (Italy) in engineering, manufacturing 
        and construction study is higher, 32.2% in bachelor degree and 37.1%. in master degree. 
        An additional aim of the project is to attract women's participation in STEM, 
        especially in the area of engineering - mechatronics which is considered "famous" for 
        the lack of female students. The project activities will be focused on the exchange of 
        good practices of female students and educators in research and education (project 
        groups of three of participating universities are led by female professors) to attract 
        their involvement. Thanks to the dissemination of the project results, specific 
        accessible activities and attractive activities for women in the project will increase 
        their interest in studying mechatronics.    
    </AccordionItem>
    <AccordionItem title="HORIZONTAL: Addressing digital transformation through development of digital readiness, resilience and capacity" mdxType="AccordionItem">
        This project also aims at improving the digital competences in engineering areas with 
        the new educational approach developed during the project.  In addition, this proposal 
        has been projected under the umbrella of digital skills.  The main collaborations, 
        competences improvement, designs and devices, or the especific documentation will use 
        digital technology and therefore contributes to the development of digital readiness, 
        resilience and capacity.
    </AccordionItem>
    </Accordion>
    <h2>{`Topics`}</h2>
    <ul>
      <li parentName="ul">{`Digital skills and competences`}</li>
      <li parentName="ul">{`Development of training courses`}</li>
      <li parentName="ul">{`Key competences development`}</li>
    </ul>
    <h2>{`Objectives`}</h2>
    <ol>
      <li parentName="ol">{`Strengthening partnerships and exchanging good practices in mechatronics engineering`}</li>
      <li parentName="ol">{`Increasing digital upskilling of European professionals to build the competencies needed to keep the pace of fast-paced
digital technology development`}</li>
      <li parentName="ol">{`Closing gender gap in STEM (Science, Technology, Engineering, and Math)`}</li>
      <li parentName="ol">{`Boosting sustainable economic growth and competitiveness by reinforcing the innovation capacity`}</li>
      <li parentName="ol">{`The integration of the Knowledge Triangle`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      